import { Button, ClickEvent } from "@mcleod/components";
import { AutogenLayoutPartnerXCmp } from "./autogen/AutogenLayoutPartnerXCmp";

export class PartnerXCmp extends AutogenLayoutPartnerXCmp {
  private _isInvoice: boolean = false;
  private _saveButton = new Button({
    id: "",
    caption: "Save & Close",
    backgroundColor: "primary",
    color: "primary.reverse",
    minWidth: 128,
    borderWidth: 0,
    rowBreak: false,
    enabled: false,
    fontBold: true,
    tooltip: "Save exclude fields for compare operations"
  });

  public get saveButton() {
    return this._saveButton;
  }

  public set saveButton(value) {
    this._saveButton = value;
  }

  public get isInvoice(): boolean {
    return this._isInvoice;
  }

  public set isInvoice(value: boolean) {
    this._isInvoice = value;
  }

  /** This is an event handler for the onClick event of buttonSelectAll. */
  buttonSelectAllOnClick(event: ClickEvent) {
    // Get the data source
    const dataSource = this.sourceEdipartnerXcmp;

    // Iterate through all rows in the data source and set exclude_field to "Y"
    if (dataSource && dataSource.data) {
      dataSource.data.forEach((row: any) => {
        // Set the exclude_field to "Y" for each row (string value for boolean fields)
        row.set("exclude_field", this.isInvoice ? "N" : "Y");
      });
    }

    // Refresh the components to reflect the changes
    dataSource.displayDataInBoundComponents();
  }

  /** This is an event handler for the onClick event of buttonUnselectAll. */
  buttonUnselectAllOnClick(event: ClickEvent) {
    // Get the data source
    const dataSource = this.sourceEdipartnerXcmp;

    // Iterate through all rows in the data source and set exclude_field to "N"
    if (dataSource && dataSource.data) {
      dataSource.data.forEach((row: any) => {
        // Set the exclude_field to "N" for each row (string value for boolean fields)
        row.set("exclude_field", this.isInvoice ? "Y" : "N");
      });
    }

    // Refresh the components to reflect the changes
    dataSource.displayDataInBoundComponents();
  }

  setColumnsForInvoice() {
    this.isInvoice = true;
    this.removeColumnById("columnExclude");
    this.labelExcludeText.visible = false;
    this.labelIncludeText.visible = true;
  }

  setColumnsForTender() {
    this.isInvoice = false;
    this.removeColumnById("columnHeaderInclude");
    this.labelExcludeText.visible = true;
    this.labelIncludeText.visible = false;
  }

  private removeColumnById(columnId: string) {
    const column = this.tablePartnerXcmp.columns.find(column => columnId === column.headingCell.id);
    if (column) {
      this.tablePartnerXcmp.removeColumn(column);
    }
  }
}
